import { useMutation } from '@tanstack/react-query';
import {
  signInWithPopup,
  getAdditionalUserInfo,
  GoogleAuthProvider,
} from 'firebase/auth';
import { getFirebaseErrorMessage } from '@/utils/exceptions/firebaseErrors.ts';
import { auth } from '@/lib/firebase';
import { useNavigate } from '@tanstack/react-router';
import { toast } from 'sonner';
import { FirebaseError } from 'firebase/app';

export default function useCreateUserWithGoogle(redirectUrl?: string) {
  const navigate = useNavigate();

  const createUserWithGoogle = async () => {
    const provider = new GoogleAuthProvider();
    return await signInWithPopup(auth, provider);
  };

  return useMutation({
    mutationFn: createUserWithGoogle,
    onSuccess: (result) => {
      const isNewUser = getAdditionalUserInfo(result)?.isNewUser;
      if (redirectUrl) {
        toast.success(
          isNewUser ? 'Konto utworzone przez Google' : 'Zalogowano pomyślnie',
        );
        window.location.href = redirectUrl;
      } else if (isNewUser) {
        toast.success('Konto utworzone przez Google', {
          description: 'Przejdź do następnego kroku, aby uzupełnić profil.',
        });
        navigate({ to: '/auth/complete-profile' });
      } else {
        toast.success('Zalogowano pomyślnie');
        navigate({ to: '/app' });
      }
    },
    onError: (error) => {
      if (error instanceof FirebaseError) {
        const errorMessage = getFirebaseErrorMessage(error?.code);
        toast.error(errorMessage);
      } else {
        toast.error('Błąd rejestracji przez Google', {
          description: error.message,
        });
      }
    },
  });
}
